import type { FunctionComponent } from 'react';

import useDeleteMfaMethod from '../../../../hooks/api/auth/mfa/useDeleteMfaMethod';
import useSetDefaultMfaMethod from '../../../../hooks/api/auth/mfa/useSetDefaultMfaMethod';
import { Badge, BUTTON_SIZE, BUTTON_TYPE } from '../../../generic';
import Button from '../../../generic/Button/Button';
import Flex from '../../../generic/Flex';
import type { MfaMethodListItem } from '../../../../../shared/types/routes/auth/mfa';

import { getTitleAndDescriptionByType } from './index';

type Props = {
  method: MfaMethodListItem;
};

const MethodHeader: FunctionComponent<Props> = ({ method }) => {
  const {
    onDeleteMfaMethod,
    isDeleting,
  } = useDeleteMfaMethod();
  const {
    mutate: setAsDefault,
    isPending: isSettingDefault,
  } = useSetDefaultMfaMethod();

  const { title, description } = getTitleAndDescriptionByType(method.type);

  return (
    <Flex direction="column" align="flex-start" justify="flex-start" gap="12px">

      <Flex direction="column" align="flex-start" justify="flex-start" gap="12px" className="width-full">
        <Flex align="center" justify="space-between" gap="8px" className="width-full">
          <strong>{title}</strong>
          {method.isDefault ?
            <Badge color="light-green">Default</Badge>
            :
            <Button
              type={BUTTON_TYPE.OUTLINE}
              size={BUTTON_SIZE.MICRO}
              onClick={() => setAsDefault(method.id)}
              isDisabled={isSettingDefault}
            >
              Set as Default
            </Button>}

          <div className="margin-left-auto">
            <Button
              type={BUTTON_TYPE.ERROR}
              size={BUTTON_SIZE.MICRO}
              onClick={() => onDeleteMfaMethod(method.id)}
              isDisabled={isDeleting}
            >
              Remove
            </Button>
          </div>
        </Flex>
        <div>{description}</div>
      </Flex>

      <div className="text-muted">
        Added on {new Date(method.createdAt).toLocaleString()}
      </div>

    </Flex>
  );
};

export default MethodHeader;
